<div class="vitamui-heading">
  <vitamui-title-breadcrumb [data]="dataBreadcrumb">
    <div class="d-flex align-items-center d-flex">
      <vitamui-common-user-photo class="mr-1" [photo]="account?.photo"></vitamui-common-user-photo>
      <span class="pl-2">{{ 'ACCOUNT.TITLE' | translate }}</span>
    </div>
  </vitamui-title-breadcrumb>

  <div class="d-flex">
    @if (displayAppTab) {
      <div>
        <button class="btn primary btn-header">Demander une modification</button>
        <button class="btn primary">Contacter l'administrateur</button>
      </div>
    }
  </div>
</div>

<div class="vitamui-content">
  <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
    <mat-tab [label]="'ACCOUNT.TAB.INFORMATIONS' | translate">
      <vitamui-common-account-information-tab [account]="account"></vitamui-common-account-information-tab>
    </mat-tab>
  </mat-tab-group>
</div>
